export default __webpack_public_path__ + "static/media/hello.eb2bee56.png";